<script>
import ListItem from "./ListItem.vue";

export default {
  components: {
    ListItem,
  },
  data() {
    return {
      selected: null,
      opened: false,
    };
  },
  props: ["options", "name", "handleSelection","preselect"],
  async mounted() {
    if(this.preselect){// this check if theres any preselected value
      this.selected = this.preselect
    }
  },
  methods: {
    onClickOutside() {
      this.onClose()
    },
    handleSelect(selected) {
      this.selected = selected;
      this.handleSelection(selected)
    },
    toggleOpen() {
      this.opened = !this.opened;
    },
    onClose () {
      this.opened = false
    }
  },
  computed: {
    labels() {
      return this.selected ? `${this.selected.label}` : "Select an Option";
    }
  }
};
</script>
<template>
  <div v-click-outside="onClickOutside" class="relative inline-block text-left">
    <div  >
      <button
        type="button"
        class="
          inline-flex
          justify-center
          w-full
          rounded-md
          border border-gray-300
          shadow-sm
          px-4
          py-2
          bg-white
          text-sm
          font-medium
          text-gray-700
          hover:bg-gray-50
          focus:outline-none
          focus:ring-2
          focus:ring-offset-2
          focus:ring-offset-gray-100
          focus:ring-indigo-500 
          btn-drop
        "
        id="menu-button"
        aria-expanded="true"
        aria-haspopup="true"
        @click="toggleOpen"
      >
        <span style="vertical-align: sub;">{{ labels }}</span>
        <i v-if="!opened" aria-hidden="true" class="v-icon notranslate mdi mdi-menu-down theme--light svg-arrow"></i>
        <i v-if="opened" aria-hidden="true" class="v-icon notranslate mdi mdi-menu-up theme--light svg-arrow"></i>
        <!-- <svg
          class="-mr-1 ml-2 h-5 w-5 svg-arrow"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          v-if="!opened"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 svg-arrow"
          viewBox="0 0 20 20"
          fill="currentColor"
          v-if="opened"
        >
          <path
            fill-rule="evenodd"
            d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
            clip-rule="evenodd"
          />
        </svg> -->
      </button>
    </div>

    <!--
    Dropdown menu, show/hide based on menu state.

    Entering: "transition ease-out duration-100"
      From: "transform opacity-0 scale-95"
      To: "transform opacity-100 scale-100"
    Leaving: "transition ease-in duration-75"
      From: "transform opacity-100 scale-100"
      To: "transform opacity-0 scale-95"
  -->
    <div
      class="
        scrollable
        origin-top-right
        absolute
        right-0
        mt-2
        w-56
        rounded-md
        shadow-lg
        bg-white
        ring-1 ring-black ring-opacity-5
        divide-y divide-gray-100
        focus:outline-none
      "
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabindex="-1"
      v-if="options.length > 0 && opened"
    >
          <!-- v-closable="{
        exclude: ['button'],
        handler: 'onClose'
      }" -->
      <list-item
        v-for="option in options"
        :key="option.id"
        :item="option"
        :name="name"
        :handleSelect="handleSelect"
        :preselect="preselect"
      ></list-item>
    </div>
  </div>
</template>

<style scoped>
.svg-arrow{
  display: inline-block;
  max-width: 20px;
  float: right;
}

.btn-drop{
  width: 100%;
  text-align: left;
}
.scrollable{
  overflow-y: scroll;
  max-height: 400px;
}
</style>